import { ArrowLeft } from "lucide-react"
import { cn } from "../lib/utils"
import { gsap } from "gsap"
import useAnimationStore from "../stores/use-animation"
import { useRef, useEffect  } from "react"
import { useNavigate } from "react-router-dom"
export default function BackButton () {
  const navigate = useNavigate()
  const { isShowResult} = useAnimationStore()
  const buttonRef = useRef()
  const timeline = useRef()
  useEffect(() => {
    timeline.current = gsap.timeline({paused: true}).to(buttonRef.current, { color: "#F9F9FF"})

    return () => {
      timeline.current.kill()
    }
  }, [])
  useEffect(() => {
    isShowResult ? timeline.current.play() : gsap.delayedCall(3, () => timeline.current.reverse())
  }, [isShowResult])

  const handleBack = (e) => {
    e.stopPropagation()
    window.location.reload()

  }
  return (
    <button
    ref={buttonRef}
    className={cn("flex flex-row items-center justify-center fixed top-8 left-8 text-gold"
    )}
    onClick={(e) => handleBack(e)}
    >
      <ArrowLeft />
      Quay lại
    </button>
  )
}
